import { FC, useRef } from 'react';
import ReactHlsPlayer from 'react-hls-player';

import { InputTitle } from 'components/input/InputTitle';
import { FileUpload, Spacing, Typography } from 'enable-ui';

import { CustomFileUpload } from '../styles/dashboard';

import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';

import { MAX_VIDEO_SIZE } from 'constants/avatar';
import { COLOR_CONFIG } from 'constants/color';

export const Video: FC<{
  videoUrl: string;
  handleGetWidthAndHeightVideo: (e: any) => void;
  handleRemoveVideo: () => void;
  onChangeVideo: (file: File[]) => void;
}> = ({ videoUrl, handleGetWidthAndHeightVideo, handleRemoveVideo, onChangeVideo }) => {
  const playerRef = useRef<HTMLVideoElement>(null);

  return (
    <Spacing spacing="xl" placement="bottom" type="margin" style={{ maxWidth: 800 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <InputTitle
          title={
            <Typography size={14} height={20} weight={600} color={COLOR_CONFIG['neutral-text']}>
              Instruction video (maximum upload file size: 200MB)
            </Typography>
          }
        />
      </div>

      {videoUrl ? (
        <div>
          {videoUrl.includes('.m3u8') ? (
            <ReactHlsPlayer
              src={videoUrl}
              autoPlay={false}
              controls={true}
              playerRef={playerRef}
              style={{
                border: `1px solid ${COLOR_CONFIG['dwarven-bronze']}`,
                borderRadius: 12,
                maxWidth: 800,
                maxHeight: 800,
              }}
            />
          ) : (
            <video
              onLoadedMetadata={handleGetWidthAndHeightVideo}
              src={videoUrl}
              controls
              style={{
                border: `1px solid ${COLOR_CONFIG['dwarven-bronze']}`,
                borderRadius: 12,
                maxWidth: 800,
                maxHeight: 800,
              }}
            />
          )}

          <Typography
            variant="body-3"
            color={COLOR_CONFIG.red}
            style={{
              whiteSpace: 'nowrap',
              cursor: 'pointer',
            }}
            onClick={handleRemoveVideo}
          >
            Remove video
          </Typography>
        </div>
      ) : (
        <CustomFileUpload>
          <FileUpload
            id={'video'}
            icon={<UploadIcon />}
            title="Click or drag and drop to upload"
            onChangeFiles={onChangeVideo}
            accept=".mp4"
            style={{ height: 240 }}
            maxFileSize={MAX_VIDEO_SIZE}
          />
        </CustomFileUpload>
      )}
    </Spacing>
  );
};
